const defaultBroadcastServiceSender = window?.BroadcastChannel ? new BroadcastChannel('broadcast_default') : undefined;
const defaultBroadcastServiceReceiver = defaultBroadcastServiceSender ? new BroadcastChannel(defaultBroadcastServiceSender.name) : undefined;

export { defaultBroadcastServiceReceiver, defaultBroadcastServiceSender };
